import EzController from 'controllers/ez-base-controller';

export default class EzDoubleRangeController extends EzController {
  static targets = [
    'rangeA',
    'rangeB',
    'activeTrack',
    'displayLeft',
    'displayRight',
  ]

  connect() {
    this.rangeMin = this.rangeATarget.min;
    this.rangeMax = this.rangeATarget.max;
    this.rangeBasis = this.rangeMax - this.rangeMin;

    this.rangeChange();
  }

  rangeChange = () => {
    const rangeAValue = parseFloat(this.rangeATarget.value);
    const rangeBValue = parseFloat(this.rangeBTarget.value);

    const minValue = rangeAValue <= rangeBValue ? rangeAValue : rangeBValue;
    const maxValue = rangeAValue > rangeBValue ? rangeAValue : rangeBValue;

    const activeTrackLeftPerc = ((minValue - this.rangeMin) / this.rangeBasis) * 100;
    this.activeTrackTarget.style.left = `${activeTrackLeftPerc}%`;

    const activeTrackRightPerc = ((this.rangeMax - maxValue) / this.rangeBasis) * 100;
    this.activeTrackTarget.style.right = `${activeTrackRightPerc}%`;

    this.selectedMaxRange(activeTrackRightPerc);
    this.setRangeDisplay(minValue, maxValue);
  }

  selectedMaxRange = (selectedMaxRangeValue) => (
    selectedMaxRangeValue === 0
      ? this.element.classList.add('selected-max-range')
      : this.element.classList.remove('selected-max-range'))

  setRangeDisplay = (leftValue, rightValue) => {
    this.displayLeftTarget.innerHTML = leftValue;
    this.displayRightTarget.innerHTML = rightValue;
  }
}
